import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MaterialModule } from "./material.module";
import { LayoutModule } from "@angular/cdk/layout";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { EnvironmentStatusModule, ENVIRONMENT_STATUS_CONFIG } from "./modules/shared/environment-status";
import { AppUserModule } from "./modules/shared/app-user";
import { SHOW_LOADING_FOR_GET, LoadingStatusModule } from "./modules/shared/loading-status";
import { AppComponent } from "./components/app/app.component";
import { PrimaryNavigationMenuComponent } from "./components/primary-navigation-menu/primary-navigation-menu.component";
import { NotificationMessageComponent } from "./services/message/notification-message.component";
import { DialogsModule } from "./modules/shared/dialogs";
import { ApiModule, Configuration, ConfigurationParameters } from "@hydrantid/acm-client";
import { LetDirective } from "@ngrx/component";
import { AccountsModule } from "./modules/shared/accounts";
import { PoliciesModule } from "./modules/shared/policies";
import { NgIdleModule } from "@ng-idle/core";
import { LogoutComponent } from "./components/logout/logout.component";
import { DialogManagePasswordComponent } from "./components/dialog-manage-password/dialog-manage-password.component";
import { DialogCertificateStatusComponent } from "./components/dialog-certificate-status/dialog-certificate-status.component";
import { NgxMaskModule } from "ngx-mask";
import { LoginComponent } from "./components/login/login.component";
import { environment } from "../configuration";
import { UsersModule } from "./modules/shared/users";
import { CertificateAuthoritiesModule } from "./modules/shared/certificate-authorities";
import { CommonModule } from "@angular/common";
import { TitleStrategy } from "@angular/router";
import { PageTitleService } from "./services/page-title/page-title.service";
import { ApplicationAuthModule } from "./auth";
import { RoleAssignmentRequiredComponent } from "./components/role-assignment-required/role-assignment-required.component";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";

export function apiConfigFactory(): Configuration {
    const params: ConfigurationParameters = {
        // set configuration parameters here.
        basePath: environment.apiRoot,
    };
    return new Configuration(params);
}

class EnvironmentStatusProvider {
    fileUrl = "";
    envName = "";

    constructor() {
        this.fileUrl = environment.statusUrl;
        this.envName = environment.environmentName;
    }
}

class ShowLoadingForGetProvider {
    showLoadingForGet = false;

    constructor() {
        this.showLoadingForGet = environment.showLoadingForGet;
    }
}

@NgModule({
    declarations: [
        AppComponent,
        LogoutComponent,
        DialogManagePasswordComponent,
        DialogCertificateStatusComponent,
        LoginComponent,
        RoleAssignmentRequiredComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        CommonModule,
        BrowserModule,
        PrimaryNavigationMenuComponent,
        ApiModule,
        ApiModule.forRoot(apiConfigFactory),
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        FontAwesomeModule,
        MaterialModule,
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        LoadingStatusModule,
        EnvironmentStatusModule,
        AccountsModule,
        PoliciesModule,
        CertificateAuthoritiesModule,
        AppUserModule,
        // Register the app-user feature before AuthEffects can emit the initial Auth0 session.
        ApplicationAuthModule,
        UsersModule,
        DialogsModule,
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            //logOnly: environment.production, // Restrict extension to log-only mode
        }),
        LetDirective,
        NgIdleModule.forRoot(),
        NgxMaskModule.forRoot(),
        NotificationMessageComponent,
    ],
    providers: [
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: "dynamic" } },
        { provide: TitleStrategy, useClass: PageTitleService },
        { provide: ENVIRONMENT_STATUS_CONFIG, useClass: EnvironmentStatusProvider },
        { provide: SHOW_LOADING_FOR_GET, useClass: ShowLoadingForGetProvider },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
